module.exports = __webpack_public_path__ + "img/roanoke-star.0e66df7c.jpeg";